import { render, staticRenderFns } from "./OleMiss116Lab3PrelabQ3.vue?vue&type=template&id=0a9d697a&scoped=true&"
import script from "./OleMiss116Lab3PrelabQ3.vue?vue&type=script&lang=js&"
export * from "./OleMiss116Lab3PrelabQ3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d697a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup})
